<template>
  <div class="flex items-center">
    <input-with-error-message v-if="isRenameMode"
                              id="app-header-name-input"
                              :value.sync="itemName"
                              :is-loading="isLoading"
                              @escape="$emit('set-rename-mode', { mode: false, id: item.id, fromAppHeader: true })"
                              @submit="$emit('rename',{ ...item,  name: $event })"
                              class="w-full h-full"
    />

    <div v-else class="flex items-center">
      <span class="font-bold text-black-soft text-xl">
        {{ item.name }}
      </span>
      <slot name="multi-bot-item-selector" />
    </div>

    <span v-if="isCopied" class="ml-4">Copied to clipboard!</span>
    <side-list-menu v-else-if="!isRenameMode && menuBuilder(item).length"
                    :items="menuBuilder(item)"
                    class="ml-4"
                    @show="$emit('show', { id: item.id })"
                    @copy-code="$emit('copy-code', item.id)"
                    @rename="$emit('set-rename-mode', { mode: true, id: item.id, fromAppHeader: true })"
                    @toggle-publish-all-markets="$emit('toggle-publish-all-markets', item)"
                    @delete="$emit('request-delete', item)"
                    @enable-auto-translate="$emit('enable-auto-translate', item)"
    />
  </div>
</template>

<script>
import InputWithErrorMessage from '@/components/common/InputWithErrorMessage.vue'
import SideListMenu from '@/components/common/SideListMenu'

export default {
  name: 'AppHeaderItemControl',

  components: {
    InputWithErrorMessage,
    SideListMenu
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    isCopied: {
      type: Boolean,
      default: false
    },
    isRenameMode: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    menuBuilder: {
      type: Function,
      default: () => {}
    }
  },

  watch: {
    item: {
      immediate: true,
      handler(item) {
        this.itemName = item.name
      }
    }
  },

  data() {
    return {
      itemName: ''
    }
  }
}
</script>
